import { inject } from "@angular/core";
import { Router } from "@angular/router";
import { UserContext } from "@app/contexts";

export const authenticationGuard = (userContext: UserContext = inject(UserContext), router: Router = inject(Router)) => {
  if (!userContext.isConnected) {
    router.navigate(['mon-compte', 'connexion']);
  }

  return userContext.isConnected;
};
